import { defineMessages } from 'react-intl';

// Query type identifiers for batch data fetching in PropertyShow. Produced
// by `BatchQueryError` in `dataBatching.js` and surfaced to the consumer via
// `usePropertyData` so the fallback UI can render a query-specific message.
// eslint-disable-next-line import/prefer-default-export
export const PROPERTY_SHOW_QUERY_TYPES = Object.freeze({
  METERS: 'metersQuery',
  RULES: 'rulesQuery',
  METER_DATA: 'meterDataQuery',
  METER_TRADE_SET_SUMMARY: 'meterTradeSetSummaryQuery',
  RULE_COUNT: 'ruleCountQuery',
});

export const messages = defineMessages({
  [PROPERTY_SHOW_QUERY_TYPES.METERS]: {
    id: 'property.property_show.helpers.error_modal.meters_query.body.message',
    defaultMessage: 'An error occurred while loading meters. Please try again.',
  },
  [PROPERTY_SHOW_QUERY_TYPES.RULES]: {
    id: 'property.property_show.helpers.error_modal.rules_query.body.message',
    defaultMessage: 'An error occurred while loading rules. Please try again.',
  },
  [PROPERTY_SHOW_QUERY_TYPES.METER_DATA]: {
    id: 'property.property_show.helpers.error_modal.meter_data_query.body.message',
    defaultMessage: 'An error occurred while loading meter data. Please try again.',
  },
  [PROPERTY_SHOW_QUERY_TYPES.METER_TRADE_SET_SUMMARY]: {
    id: 'property.property_show.helpers.error_modal.meter_trade_set_summary_query.body.message',
    defaultMessage: 'An error occurred while loading meter trade set summaries. Please try again.',
  },
  [PROPERTY_SHOW_QUERY_TYPES.RULE_COUNT]: {
    id: 'property.property_show.helpers.error_modal.rule_count_query.body.message',
    defaultMessage: 'An error occurred while loading the property rules count. Please try again.',
  },
});
